import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import * as $ from 'jquery';
import { NavbarStyleOneComponent } from '../../common/navbar-style-one/navbar-style-one.component';

@Component({
  selector: 'app-products-details',
  templateUrl: './products-details.component.html',
  styleUrls: ['./products-details.component.scss']
})
export class ProductsDetailsComponent implements OnInit {
  productID: any
  productDetails: any

  constructor(private url: ActivatedRoute,private router: Router,private api: ApiService,private encrypt: EncryptionService) { }

  ngOnInit(): void {
    if(this.url.snapshot.params['id']){
      this.productID = this.url.snapshot.params['id'];
      // this.subCategoryName = this.url.snapshot.params['subCatName']
      console.log(this.productID)
    }

    if(this.productID){
      this.api.specificProduct(this.productID).subscribe({
        next: (response: any) => {
          this.productDetails = response.data.selectedProduct
          // console.log(this.productDetails)
        },error: (error: HttpErrorResponse) => {

        }
      })
    }

    this.quantityCounter = 0
    const quan = localStorage.getItem('quantity')
    if(parseInt(quan) > 0){
      this.quantityCounter = parseInt(quan)
    }

    this.isFav = false
    setTimeout(() => {
      this.api.getFavoriteProducts().subscribe({
        next: (response) => {
          // console.log(response.data.data)
          const fav = response.data.data.filter( (item: any) => item.id == this.productID)
          if(fav.length > 0){
            // console.log(fav)
            this.isFav = true
          }
        }, error: (error: HttpErrorResponse) => {
          console.log(error);
        }
      })
    }, 500);
  }

  productQuantities: { [key: number]: number } = {}; // Store quantity per product
  selectedPrice: number = 0; // Store the selected price

  // Function to update product quantity and recalculate the total price
  quantity(productId: number, change: number) {
    if (!this.productQuantities[productId]) {
      this.productQuantities[productId] = 0; // Initialize if not set
    }
    this.productQuantities[productId] += change;
    // Ensure the quantity is not negative
    if (this.productQuantities[productId] < 0) {
      this.productQuantities[productId] = 0;
    }
    // Update the total quantity
    this.getTotalAddedQuantity();
    // Recalculate the total price whenever quantity is changed
    this.calcTotal(this.selectedPrice);
  }

  // Calculate total quantity of all added products
  totalQuantityAmount: number = 0;
  getTotalAddedQuantity(): number {
      this.totalQuantityAmount = Object.values(this.productQuantities).reduce((total, qty) => total + qty, 0);
      return this.totalQuantityAmount;
  }

  // Function to update price when size is selected
  lastValue: number = 0;
  calcTotal(typePrice: number,type?: any) {
    if (type && this.productDetails) {
      this.selectedSizes[this.productDetails.id] = type;
    }
    this.selectedPrice = typePrice; // Store the selected price
    this.getTotalAddedQuantity(); // Update total quantity
    this.lastValue = this.totalQuantityAmount * this.selectedPrice;
  }


  signInFirst: boolean = false;
  selectedSizes: { [key: number]: any } = {};
  selectSize(productId: number, type: any) {
    this.selectedSizes[productId] = type;
  }

  @ViewChild(NavbarStyleOneComponent) navbarComponent: NavbarStyleOneComponent;
  showSuccess: boolean = false;
  successMsg = ''
  sendCart() {
    const cartData = {
      products: Object.keys(this.productQuantities)
      .filter(productId => this.productQuantities[+productId] > 0) // Only include products with quantity > 0
      .map(productId => ({
          product_id: +productId,
          type: this.selectedSizes[+productId]?.id || null, // Get selected type
          quantity: this.productQuantities[+productId]
      }))
    };
    console.log(this.selectedSizes)
    console.log(cartData); // Debugging
    this.api.addToCart(cartData).subscribe({
      next: (response) => {
        // console.log(response);
        if(response.success == true){
          this.showSuccess = true
          this.successMsg = "تمت اضافة المنتج بنجاح"
          setTimeout(() => {
            this.showSuccess = false
            this.successMsg = ''
          }, 3000);
          // this.navbarComponent.refreshCart = false
          this.navbarComponent.getCart();
        }
      },error: (error: HttpErrorResponse) => {
        if(error.error.message == "Sign in first"){
          this.signInFirst = true;
          $('#openModal').click();
        }
      }
    });
  }

  goBack(){
    history.back()
  }

  isFav: boolean = false;
  quantityCounter: any
  toggleFavourite(id: number){
    // $('.heart-btn .fa-haert').toggleClass('fa-regular')
    this.api.toggleFavoriteProduct(id).subscribe({
      next: (response) => {
        // console.log(response)
        if(response.success == true){
          this.isFav = !this.isFav
        }
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }
}
